export default (value) => {
    // eslint-disable-next-line no-control-regex
    const regex = /([^\u0009\u000A\u000D\u0020-\uD7FF\uE000-\uFFFD\u{10000}-\u{10FFFF}])/ug;
    const str = value.replace(regex, '');
    return str;
  };
  